import { authFetch } from '@/lib/auth-fetch';
import { getApiBaseUrl } from '@/lib/data-service';

interface IntercomUserSignatureResponse {
  userHash: string;
}

export const intercomService = {
  async fetchUserSignature(): Promise<string> {
    const apiUrl = getApiBaseUrl();
    const response = await authFetch(`${apiUrl}/intercom/user-signature`);

    if (!response.ok) {
      throw new Error(`Failed to fetch Intercom user signature: ${response.status}`);
    }

    const data: IntercomUserSignatureResponse = await response.json();
    return data.userHash;
  },
};
